import { useId } from "react"
import { useSignal } from "~/sdk/signal"
import { ReactNode } from "react"
import { useEffect } from "react"

interface Props {
    onClose?: () => void
    open?: boolean
    className?: string
    style?: string
    children?: ReactNode
    loading?: 'eager' | 'lazy'
    id?: string
    alt?: string
}

function Modal(props: Props) {
    const { children, open, onClose, loading = 'lazy', id: _id } = props
    const lazy = useSignal(loading === 'lazy' && !open)
    const id = _id ?? useId()
    const _altId = useId()

    useEffect(() => {
        const handler = (e: KeyboardEvent) =>
            (e.key === 'Escape' || e.keyCode === 27) && open && onClose?.()

        addEventListener('keydown', handler)

        return () => removeEventListener('keydown', handler)
    }, [open])

    useEffect(() => {
        lazy.value = false
    }, [])

    return (
        <>
            <input
                id={id}
                checked={open}
                type='checkbox'
                className='modal-toggle'
                onChange={(e) => e.currentTarget.checked === false && onClose?.()}
                aria-label={props.alt}
            />

            <div className='modal !bg-black/75'>
                {!lazy.value && children}

                <label className='modal-backdrop' htmlFor={id}>
                    {props.alt ?? 'Fechar'}
                </label>
            </div>
        </>
    )
}

export default Modal
